"use client";

import { LoadingButton } from "@/components/loading-button";
import { cn } from "@/utils/utils";
import Image from "next/image";
import type { ReactNode } from "react";

interface FullPageErrorProps {
  description?: ReactNode;
  fullPage?: boolean;
  isPending?: boolean;
  onRetry?: () => void;
}

export const FullPageError = ({
  description = (
    <>
      We ran into an unexpected problem. <br /> Please try again.
    </>
  ),
  fullPage = true,
  isPending = false,
  onRetry = () => window.location.reload(),
}: FullPageErrorProps) => (
  <div
    className={cn(
      "flex w-full flex-col items-center justify-center px-6 py-12",
      fullPage ? "min-h-0 flex-1" : "h-full",
    )}
  >
    <div className="flex max-w-2xl flex-col items-center gap-6">
      <Image
        src="/new-jurni-icon-logo.svg"
        alt="Jurni"
        width={56}
        height={54}
        priority
      />

      <h1 className="text-3xl font-semibold tracking-tight text-foreground">
        Something went wrong
      </h1>
      <p className="max-w-md text-center text-muted-foreground">
        {description}
      </p>

      <LoadingButton type="button" isPending={isPending} onClick={onRetry}>
        Try again
      </LoadingButton>
    </div>
  </div>
);
